import { render } from "./NavbarLayout.vue?vue&type=template&id=5fdae832&scoped=true"
import script from "./NavbarLayout.vue?vue&type=script&lang=js"
export * from "./NavbarLayout.vue?vue&type=script&lang=js"

import "./NavbarLayout.vue?vue&type=style&index=0&id=5fdae832&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fdae832"]])

export default __exports__